<template>
  <Card :class="content_class">
    <div>
      <Card :bordered="false" dis-hover class="ivu-mb-16">
        <Form ref="formValidate" :model="formValidate" :label-width="100" label-position="right" class="tabform"
              @submit.native.prevent>
          <Row :gutter="24" type="flex">
            <Col span="24">
              <FormItem label="时间选择：">
                <RadioGroup v-model="timePeriod" type="button" class="mr" @on-change="getList">
                  <Radio label="0"><span>不限</span></Radio>
                  <Radio label="1"><span>今日</span></Radio>
                  <Radio label="2"><span>昨日</span></Radio>
                  <Radio label="3"><span>本周</span></Radio>
                  <Radio label="4"><span>上周</span></Radio>
                  <Radio label="5"><span>本月</span></Radio>
                  <Radio label="6"><span>上月</span></Radio>
                  <Radio label="7"><span>自定义</span></Radio>
                  <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate"
                              @on-change="timePeriodDateChange" type="daterange" placeholder="选择日期"
                              style="width: 200px"></DatePicker>
                </RadioGroup>
                <Button type="primary" class="bnt mr15" icon="md-add" style="margin-left: 20px;"
                        @click="addRechargeModal">记账
                </Button>
                <!-- 新增的CSV操作按钮 -->
                <Button style='margin: 0 0 0 10px' type="success" @click="handleImport">导入CSV</Button>
                <Button style='margin: 0 0 0 10px' type="warning" @click="handleExport">导出CSV</Button>
                <Button style='margin: 0 0 0 10px' type="info" @click="downloadTemplate">下载模板</Button>

                <!-- 文件上传组件（隐藏） -->
                <input
                    type="file"
                    ref="fileInput"
                    style="display: none"
                    accept=".csv,.xlsx,.xls"
                    @change="handleFileChange"
                >
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="账户：">
                <RadioGroup type="button" v-model="bankid" class="mr15" @on-change="getList">
                  <Radio label="0"><span>全部</span></Radio>
                  <Radio :label="item.id" v-for="(item,index ) in bankIdList" :key="index">{{ item.bankname }}</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="交易类型：">
                <RadioGroup type="button" v-model="classType" class="mr15" @on-change="getList">
                  <Radio label="0"><span>全部</span></Radio>
                  <Radio :label="item.id" v-for="(item,index ) in classTypeList" :key="index">{{ item.classname }}
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <div style="width: 100% ;margin-top: 20px;">
        <Table :columns="columns" :data="datas" ref="table">
          <template slot-scope="{ row, index }" slot="acmoney">
            <div style="margin: 10px;color: red;">
              <span v-if="row.pay_type == 1">+{{ row.acmoney }}</span>
            </div>
            <div style="margin: 10px;color: green;">
              <span v-if="row.pay_type == 2">-{{ row.acmoney }}</span>
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
                    :data-index="index" @click="editFlow">编辑
            </Button>
            <Button type="error" size="small" :data-id="row.id" @click="delFlow">删除</Button>
            <Button v-if="(userInfo.role_type == 9 || userInfo.role_type == 1) && row.approval_status == 0" type="warning" size="small" style="margin-left: 5px"
                    :data-id="row.id" :data-index="index" @click="showApproveModal(row)">审批
            </Button>
          </template>
        </Table>
      </div>
      <div class="pager">
        <Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
              :current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
              show-elevator/>
      </div>
      <!-- 提现申请 -->
      <Modal v-model="modal" width="500" title="添加充值">
        <Form :label-width="120">
          <FormItem label="银行卡">
            <Select v-model="rechargeForm.bankid">
              <Option v-for="item in bankIdList" :value="item.id" :key="item.id">
                {{ item.bankname }}-[{{ item.remark }}]
              </Option>
            </Select>
          </FormItem>
          <FormItem label="日期">
            <DatePicker type="date" :value="rechargeForm.actime" @on-change="rechargeTimeChange"
                        placeholder="Select date"></DatePicker>
          </FormItem>
          <FormItem label="类型">
            <Select v-model="rechargeForm.acclassid">
              <Option v-for="item in classTypeList" :value="item.id" :key="item.id">
                {{ item.pay_type_name }}-[{{ item.classname }}]
              </Option>
            </Select>
          </FormItem>
          <FormItem label="金额">
            <Input placeholder="金额" v-model="rechargeForm.acmoney"></Input>
          </FormItem>
          <FormItem label="备注">
            <Input placeholder="备注" v-model="rechargeForm.remark"></Input>
          </FormItem>
          <FormItem label="添加图片">
            <MyUpload ref="upload"></MyUpload>
          </FormItem>
        </Form>
        <div slot="footer">

          <Button type="primary" @click="rechargeSubmit">提交</Button>
          <Button type="default" @click="modal = false">取消</Button>
        </div>
      </Modal>
      <!-- 审批确认模态框 -->
      <Modal v-model="approveModal" width="400" title="审批确认">
        <Form :label-width="100">
          <FormItem label="当前状态：">
            <Tag v-if="currentItem.approval_status == 0" color="orange">待审批</Tag>
            <Tag v-else-if="currentItem.approval_status == 1" color="green">已通过</Tag>
            <Tag v-else-if="currentItem.approval_status == 2" color="red">已拒绝</Tag>
          </FormItem>
          <FormItem label="审批操作：">
            <RadioGroup v-model="approveAction">
              <Radio label="1">通过</Radio>
              <Radio label="2">拒绝</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="审批备注：" v-if="approveAction == '2'">
            <Input type="textarea" v-model="approveRemark" placeholder="请输入拒绝理由（可选）" :rows="3"/>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="submitApprove">提交</Button>
          <Button type="default" @click="approveModal = false">取消</Button>
        </div>
      </Modal>
    </div>
  </Card>
</template>
<script>
import {
  mapGetters,
  mapActions
} from "vuex";
// import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import MyUpload from '../tool/Upload.vue';
import {
  getFlowList,
  getBankIdList,
  getAllClassTypeList,
  addFlow,
  getFlow,
  delFlow,
  approval,
  importFlowData,
  exportFlowData,
  getTemplateData
} from "@/api/financeManage";
import * as XLSX from "xlsx";

export default {
  name: "FinanceFlow",
  components: {
    MyUpload
  },
  props: ['content_class'],
  data() {
    return {
      count: 0,
      page: 1,
      pageSize: 10,
      pageSizeOpts: [10, 50, 100, 500],
      name: '',
      modal: false,
      timePeriod: '5',
      timePeriodDate: [],
      rechargeForm: {
        recharge_date_time: '',
        arrival_amount: '',
        remark: '',
        status: 0
      },
      bankIdList: [],
      classTypeList: [],
      bankid: '0',
      classType: '0',
      datas: [],
      fromList: {
        title: '选择时间',
        custom: true,
        fromTxt: [
          {
            text: '全部',
            val: ''
          },
          {
            text: '今天',
            val: 'today'
          },
          {
            text: '昨天',
            val: 'yesterday'
          },
          {
            text: '本周',
            val: 'week'
          },
          {
            text: '本月',
            val: 'month'
          },
          {
            text: '本季度',
            val: 'quarter'
          },
          {
            text: '本年',
            val: 'year'
          },
        ],
      },
      formValidate: {
        status: '',
        extract_type: '',
        nireid: '',
        data: '',
        page: 1,
        limit: 20,
      },
      columns: [
        {
          "title": "账户",
          "key": "bankname",
          align: 'center'
        }, {
          "title": "交易日期",
          "key": "actime",
          align: 'center'
        },
        {
          "title": "交易金额",
          "key": "acmoney",
          align: 'center'
        },
        {
          "title": "创建时间",
          "key": "created_at",
          align: 'center'
        },
        {
          "title": "备注",
          "key": "remark",
          align: 'center'
        },
        {
          "title": "审批状态",
          "key": "approval_text",
          align: 'center'
        },
        {
          "title": "操作人",
          "key": "name",
          align: 'center'
        },
        {
          title: 'Action',
          slot: 'action',
          width: 200,
          align: 'center'
        }
      ],
      columnsCopy: [
        {
          "title": "账户",
          "key": "bankname",
          align: 'center'
        }, {
          "title": "交易日期",
          "key": "actime",
          align: 'center'
        },
        {
          "title": "交易金额",
          "slot": "acmoney",
          align: 'center'
        },
        {
          "title": "交易类型",
          "key": "classname",
          align: 'center'
        },
        {
          "title": "余额",
          "key": "balance",
          align: 'center'
        },
        {
          "title": "备注",
          "key": "remark",
          align: 'center'
        },
        {
          "title": "审批状态",
          "key": "approval_text",
          align: 'center'
        },
        {
          "title": "操作人",
          "key": "name",
          align: 'center'
        },
        {
          "title": "创建时间",
          "key": "created_at",
          align: 'center'
        },
        {
          title: 'Action',
          slot: 'action',
          width: 200,
          align: 'center'
        }
      ],
      balance: '***',
      consume: '***',
      // 审批相关数据
      approveModal: false,
      currentItem: {},  // 当前审批项
      approveAction: '1',  // 审批操作：1通过 2拒绝
      approveRemark: '',   // 审批备注
      templateFields: [
        { label: '账户ID', key: 'bankid', required: true, description: '请输入账户ID，可从系统账户管理中查看' },
        { label: '交易类型ID', key: 'acclassid', required: true, description: '请输入交易类型ID，可从系统分类管理中查看' },
        { label: '交易金额', key: 'acmoney', required: true, description: '请输入数字，如：1000.00' },
        { label: '交易日期', key: 'actime', required: true, description: '格式：2024-01-15' },
        { label: '备注', key: 'remark', required: false, description: '可选填写' }
      ],

      // 账户和交易类型映射（用于前端验证）
      accountMap: {},
      classTypeMap: {}
    }
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  mounted() {
    this.userDisplayTable();
    this.loadData();
    this.getList();
  },
  methods: {
    ...mapActions([
      'handleLogOut',
      'getUserInfo',
    ]),
    timePeriodDateChange(e) {
      this.timePeriodDate = e;
      this.getList();
    },
    rechargeTimeChange(e) {
      this.rechargeForm.actime = e;
    },
    initSearch() {

    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.formValidate.data = this.timeVal.join('-');
      this.formValidate.page = 1;
      this.getList();
    },
    // 选择时间
    selectChange(tab) {
      this.formValidate.page = 1;
      this.formValidate.data = tab;
      this.timeVal = [];
      this.getList();
    },
    addRechargeModal() {
      this.rechargeForm = {};
      this.$refs['upload'].uploadList = [];
      this.modal = true;
    },
    async loadData() {
      let that = this;
      let data = {}
      data.token = this.token;
      let res = await getBankIdList(that, data);
      that.bankIdList = res.data.list;
      res = await getAllClassTypeList(that, data);
      that.classTypeList = res.data.list;
    },
    async getList() {
      let that = this;
      let data = {
        token: that.token,
        timePeriod: that.timePeriod,
        timePeriodDate: that.timePeriodDate,
        bankid: that.bankid,
        classType: that.classType,
        page: that.page,
        pageSize: that.pageSize
      };
      let res = await getFlowList(that, data);
      if (res.code == 1) {
        that.datas = res.data.list;
        that.count = res.count;
      }
    },
    changePage(e) {
      this.page = e;
      this.getList();
    },
    changeSize(e) {
      this.pageSize = e;
      this.getList();
    },
    async rechargeSubmit() {
      let that = this;
      if (that.rechargeForm.status != 1) {
        that.rechargeForm.status = 0;
      }
      let data = {
        token: that.token,
        rechargeForm: that.rechargeForm,
        imgList: that.$refs['upload'].uploadList
      };
      let res = await addFlow(that, data);
      if (res.code == 1) {
        this.modal = false;
        this.getList();
      }
    },
    userDisplayTable() {
      // type: 4 分公司负责人   5 区长n)
      if (this.userInfo.role_type == 13) { //此处判断不用用户类型是否有有对应的列权限
        this.columns = this.columns.filter(col => col.slot !== 'action')
        this.columns = this.columns.filter(col => col.key !== 'remark')
      } else {
        this.columns = this.columnsCopy
      }
    },
    // 编辑充值
    async editFlow(e) {
      let that = this;
      let id = e.currentTarget.dataset.id;
      let data = {
        token: that.token,
        id: id,
        imgList: that.$refs['upload'].uploadList
      };
      let res = await getFlow(that, data);
      if (res.code == 1) {
        var jsonStr = JSON.parse(res.data.item.ext_info); //将视频和图片的json转为数据
        that.$refs['upload'].uploadList = jsonStr.imgList;
        that.rechargeForm = res.data.item;
        that.modal = true;
      }
    },
    // 删除充值
    delFlow(e) {
      let that = this;
      let id = e.currentTarget.dataset.id;
      that.$Modal.confirm({
        title: '确认删除吗？',
        onOk: async () => {
          that.throttle(async function () {
            let data = {
              token: that.token,
              id: id
            }
            let res = await delFlow(that, data);
            if (res.code == 1) {
              that.$Message.success('删除成功');
              that.getList();
            }
          }, 1000);
        }
      })
    },
    recharge() {
      window.open('#/PayInfo')
    },
    // 显示审批模态框
    showApproveModal(row) {
      this.currentItem = row;
      this.approveAction = '1';
      this.approveRemark = '';
      this.approveModal = true;
    },

    // 提交审批
    async submitApprove() {
      let that = this;

      try {

        let data = {
          token: that.token,
          id: that.currentItem.id,
          approval_status: parseInt(that.approveAction),  // 1通过 2拒绝
          remark: that.approveRemark
        }
        let res = await approval(that, data);
        if (res.code == 1) {
          that.$Message.success('审批成功');
          that.approveModal = false;
          await that.getList();
        } else {
          that.$Message.error(res.msg || '审批失败');
        }
      } catch (error) {
        console.error('审批接口错误:', error);
        that.$Message.error('审批失败，请稍后重试');
      }
    },

    // 新增：CSV导入方法
    handleImport() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const fileType = file.name.split('.').pop().toLowerCase();

      if (['csv', 'xlsx', 'xls'].includes(fileType)) {
        this.readFile(file, fileType);
      } else {
        this.$Message.error('请上传CSV或Excel文件');
      }

      // 清空文件选择
      event.target.value = '';
    },

    async readFile(file, fileType) {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const data = e.target.result;
        await this.processFileData(data, fileType);
      };

      if (fileType === 'csv') {
        reader.readAsText(file, 'UTF-8');
      } else {
        reader.readAsBinaryString(file);
      }
    },

    async processFileData(data, fileType) {
      try {
        let jsonData = [];

        if (fileType === 'csv') {
          jsonData = this.csvToJson(data);
        } else {
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          jsonData = XLSX.utils.sheet_to_json(worksheet);
        }

        // 验证数据
        const { validData, errors } = await this.validateImportData(jsonData);

        if (errors.length > 0) {
          this.$Modal.error({
            title: '数据验证失败',
            content: errors.slice(0, 10).join('<br>') + (errors.length > 10 ? `<br>...还有${errors.length - 10}条错误` : '')
          });
          return;
        }

        // 确认导入
        this.$Modal.confirm({
          title: '确认导入',
          content: `共发现 ${validData.length} 条有效数据，是否导入？`,
          onOk: () => {
            this.submitImportData(validData);
          }
        });

      } catch (error) {
        this.$Message.error('文件解析失败：' + error.message);
      }
    },

    csvToJson(csvText) {
      const lines = csvText.split('\n').filter(line => line.trim());
      if (lines.length === 0) return [];

      const headers = lines[0].split(',').map(header => header.trim());

      return lines.slice(1).map((line, index) => {
        const values = line.split(',');
        const obj = {};
        headers.forEach((header, i) => {
          obj[header] = values[i] ? values[i].trim() : '';
        });
        return obj;
      }).filter(item => Object.values(item).some(val => val));
    },

    async validateImportData(data) {
      console.log('data', data)
      const validData = [];
      const errors = [];

      // 加载账户和交易类型映射
      if (Object.keys(this.accountMap).length === 0 || Object.keys(this.classTypeMap).length === 0) {
        await this.loadTemplateData();
      }

      data.forEach((item, index) => {
        console.log('item', item)
        console.log('index', index)
        console.log('this.templateFields', this.templateFields)
        const lineNumber = index + 2;
        let isValid = true;

        // 检查必填字段
        this.templateFields.forEach(field => {
          if (field.required && !item[field.label]) {
            errors.push(`第${lineNumber}行：${field.label} 不能为空`);
            isValid = false;
          }
        });
        item.bankid = item.账户ID
        item.acclassid = item.交易类型ID
        item.acmoney = item.交易金额
        item.actime = item.交易日期
        item.remark = item.备注
        console.log('new item', item)
        // 验证账户ID是否存在
        if (item.bankid && !this.accountMap[item.bankid]) {
          errors.push(`第${lineNumber}行：账户ID "${item.bankid}" 不存在`);
          isValid = false;
        }

        // 验证交易类型ID是否存在
        if (item.acclassid && !this.classTypeMap[item.acclassid]) {
          errors.push(`第${lineNumber}行：交易类型ID "${item.acclassid}" 不存在`);
          isValid = false;
        }

        // 验证金额是否为数字
        if (item.acmoney && isNaN(Number(item.acmoney))) {
          errors.push(`第${lineNumber}行：交易金额 "${item.acmoney}" 必须是数字`);
          isValid = false;
        }

        // 验证日期格式
        if (item.actime && /^\d+$/.test(item.actime)) {
          const num = parseInt(item.actime);
          if (num > 40000 && num < 50000) {
            // Excel日期转Unix时间戳（秒）
            item.actime = Math.floor((num - 25569) * 86400);
          }
        }

        if (isValid) {
          // 格式化数据
          const formattedItem = {
            bankid: parseInt(item.bankid),
            acclassid: parseInt(item.acclassid),
            acmoney: parseFloat(item.acmoney),
            actime: item.actime,
            remark: item.remark || ''
          };
          validData.push(formattedItem);
        }
      });

      return { validData, errors };
    },
// 添加Excel日期转换方法
    excelDateToJSDate(excelDate) {
      // Excel日期从1899-12-30开始（注意不是1900-01-01）
      // Excel错误地认为1900是闰年，所以需要特殊处理
      const days = Math.floor(excelDate);
      const fraction = excelDate - days;

      // 计算日期（从1899-12-30开始）
      let date = new Date(1899, 11, 30); // 1899年12月30日

      // 添加天数
      date.setDate(date.getDate() + days);

      // 处理Excel的1900闰年错误
      if (excelDate >= 60) {
        date.setDate(date.getDate() - 1);
      }

      // 添加时间部分（如果有的话）
      const millisecondsPerDay = 24 * 60 * 60 * 1000;
      date.setTime(date.getTime() + fraction * millisecondsPerDay);

      return date;
    },
    async loadTemplateData() {
      try {
        const that = this;
        const data = { token: this.token };
        const res = await getTemplateData(that, data);

        if (res.code == 1) {
          // 构建账户映射
          res.data.accounts.forEach(account => {
            this.accountMap[account.id] = account.bankname;
          });

          // 构建交易类型映射
          [...res.data.incomeTypes, ...res.data.outcomeTypes].forEach(type => {
            this.classTypeMap[type.id] = type.name;
          });
        }
      } catch (error) {
        console.error('加载模板数据失败:', error);
      }
    },

    async submitImportData(data) {
      try {
        const that = this;
        const importData = {
          token: this.token,
          data: data
        };

        // 显示加载中
        const loading = this.$Message.loading({
          content: '正在导入数据...',
          duration: 0
        });

        const res = await importFlowData(that, importData);

        setTimeout(() => {
          loading();
        }, 300);

        if (res.code == 1) {
          this.$Message.success(res.msg || `成功导入 ${data.length} 条数据`);
          // 刷新列表
          this.getList();
        } else {
          this.$Message.error(res.msg || '导入失败');
        }
      } catch (error) {
        this.$Message.error('导入失败：' + error.message);
      }
    },

    // 新增：CSV导出方法
    async handleExport() {
      try {
        const that = this;

        const loading = this.$Message.loading({
          content: '正在生成导出文件...',
          duration: 0
        });

        // 构建导出参数
        const exportParams = {
          token: this.token,
          timePeriod: this.timePeriod,
          timePeriodDate: this.timePeriodDate,
          bankid: this.bankid !== '0' ? this.bankid : '',
          classType: this.classType !== '0' ? this.classType : ''
        };

        const res = await exportFlowData(that, exportParams);

        setTimeout(() => {
          loading();
        }, 300);

        if (res.code == 1) {
          const exportData = res.data.list;

          // 创建Workbook
          const worksheet = XLSX.utils.json_to_sheet(exportData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "流水数据");

          // 设置列宽
          const wscols = [
            { wch: 20 }, // 账户名称
            { wch: 15 }, // 交易日期
            { wch: 12 }, // 交易金额
            { wch: 10 }, // 收支类型
            { wch: 15 }, // 交易分类
            { wch: 12 }, // 余额
            { wch: 20 }, // 备注
            { wch: 15 }, // 审批状态
            { wch: 10 }, // 操作人
            { wch: 20 }  // 创建时间
          ];
          worksheet['!cols'] = wscols;

          // 生成Excel文件
          const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
          });

          const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          const fileName = `流水数据_${new Date().toLocaleDateString().replace(/\//g, '-')}.xlsx`;
          saveAs(blob, fileName);

          this.$Message.success('导出成功');
        } else {
          this.$Message.error(res.msg || '导出失败');
        }

      } catch (error) {
        this.$Message.error('导出失败：' + error.message);
      }
    },

    // 新增：下载模板方法
    async downloadTemplate() {
      try {
        // 加载账户和交易类型数据
        if (Object.keys(this.accountMap).length === 0 || Object.keys(this.classTypeMap).length === 0) {
          await this.loadTemplateData();
        }

        // 创建说明行
        const instructions = {
          '账户ID': '请填写账户ID（必填）',
          '交易类型ID': '请填写交易类型ID（必填）',
          '交易金额': '请填写金额，如：1000.00（必填）',
          '交易日期': '请填写日期，格式：2024-01-15（必填）',
          '备注': '可选填写'
        };

        // 创建示例数据
        const exampleData = {
          '账户ID': '1',
          '交易类型ID': '1',
          '交易金额': '1000.00',
          '交易日期': '2024-01-15',
          '备注': '示例备注'
        };

        // 创建账户说明工作表
        const accountSheetData = [
          ['账户ID', '账户名称'],
          ...Object.entries(this.accountMap).map(([id, name]) => [id, name])
        ];

        // 创建交易类型说明工作表
        const classTypeSheetData = [
          ['交易类型ID', '交易类型名称'],
          ...Object.entries(this.classTypeMap).map(([id, name]) => [id, name])
        ];

        // 创建主Workbook
        const workbook = XLSX.utils.book_new();

        // 添加说明工作表
        const instructionWS = XLSX.utils.json_to_sheet([instructions, exampleData]);
        XLSX.utils.book_append_sheet(workbook, instructionWS, "导入说明");

        // 添加账户列表工作表
        const accountWS = XLSX.utils.aoa_to_sheet(accountSheetData);
        XLSX.utils.book_append_sheet(workbook, accountWS, "账户列表");

        // 添加交易类型列表工作表
        const classTypeWS = XLSX.utils.aoa_to_sheet(classTypeSheetData);
        XLSX.utils.book_append_sheet(workbook, classTypeWS, "交易类型列表");

        // 生成Excel文件
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        saveAs(blob, '流水数据导入模板.xlsx');

        this.$Message.success('模板下载成功，请按照说明填写数据');

      } catch (error) {
        this.$Message.error('模板下载失败：' + error.message);
      }
    },
  },


}
</script>
<style scoped lang="less">
.content {
}

.ivu-mt .type .item {
  margin: 3px 0;
}

.tabform {
}

.content1 {
  height: 650px;
  overflow-y: auto;
  overflow-x: hidden
}

.yellow_btn {
  color: #F8BD66;
}

.multiple {
  display: flex;
  justify-content: left;
  margin-top: 10px;
  align-items: center;

  .child-div {
    width: 70px;
    height: 20px;
    margin-right: 30px;
    text-align-last: justify;
  }
}


.sousuo {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.yl-flex {
  display: flex;
}

.flex_between {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>